import { IndependentTimeData, FeiertageTimeData, ComponentState } from '../types';

export const LAND_OPTIONS = [
  { value: 'Deutschland', label: 'timeInformation.countries.deutschland' },
  { value: 'Österreich', label: 'timeInformation.countries.österreich' },
  { value: 'Schweiz', label: 'timeInformation.countries.schweiz' }
] as const;

export const TIMEZONE_OPTIONS = [
  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)' },
  // Europe
  { value: 'Europe/Vienna', label: 'Wien / Vienna (CET/CEST)' },
  { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)' },
  { value: 'Europe/Zurich', label: 'Zürich (CET/CEST)' },
  { value: 'Europe/London', label: 'London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Paris (CET/CEST)' },
  { value: 'Europe/Rome', label: 'Rom / Rome (CET/CEST)' },
  { value: 'Europe/Madrid', label: 'Madrid (CET/CEST)' },
  { value: 'Europe/Amsterdam', label: 'Amsterdam (CET/CEST)' },
  { value: 'Europe/Brussels', label: 'Brüssel / Brussels (CET/CEST)' },
  { value: 'Europe/Prague', label: 'Prag / Prague (CET/CEST)' },
  { value: 'Europe/Warsaw', label: 'Warschau / Warsaw (CET/CEST)' },
  { value: 'Europe/Stockholm', label: 'Stockholm (CET/CEST)' },
  { value: 'Europe/Helsinki', label: 'Helsinki (EET/EEST)' },
  { value: 'Europe/Athens', label: 'Athen / Athens (EET/EEST)' },
  { value: 'Europe/Moscow', label: 'Moskau / Moscow (MSK)' },
  // Americas
  { value: 'America/New_York', label: 'New York (EST/EDT)' },
  { value: 'America/Chicago', label: 'Chicago (CST/CDT)' },
  { value: 'America/Denver', label: 'Denver (MST/MDT)' },
  { value: 'America/Los_Angeles', label: 'Los Angeles (PST/PDT)' },
  { value: 'America/Toronto', label: 'Toronto (EST/EDT)' },
  { value: 'America/Sao_Paulo', label: 'São Paulo (BRT)' },
  { value: 'America/Mexico_City', label: 'Mexiko-Stadt / Mexico City (CST/CDT)' },
  // Asia
  { value: 'Asia/Tokyo', label: 'Tokio / Tokyo (JST)' },
  { value: 'Asia/Shanghai', label: 'Shanghai (CST)' },
  { value: 'Asia/Hong_Kong', label: 'Hongkong / Hong Kong (HKT)' },
  { value: 'Asia/Singapore', label: 'Singapur / Singapore (SGT)' },
  { value: 'Asia/Dubai', label: 'Dubai (GST)' },
  { value: 'Asia/Kolkata', label: 'Mumbai / Kolkata (IST)' },
  { value: 'Asia/Seoul', label: 'Seoul (KST)' },
  // Oceania
  { value: 'Australia/Sydney', label: 'Sydney (AEST/AEDT)' },
  { value: 'Australia/Melbourne', label: 'Melbourne (AEST/AEDT)' },
  { value: 'Pacific/Auckland', label: 'Auckland (NZST/NZDT)' },
] as const;

export const DATENFORM_OPTIONS = [
  { value: '', label: '' },
  { value: 'Zeithorizont', label: '' },
  { value: 'Aktuelle Zeit', label: '' },
] as const;

export const INITIAL_INDEPENDENT_DATA: IndependentTimeData = {
  detaillierteBerechnung: false,
  datenform: '',
  zeithorizontStart: '',
  zeithorizontEnd: '',
  skalierung: 'ja',
  skalierungMin: '0',
  skalierungMax: '1'
};

export const INITIAL_FEIERTAGE_DATA: FeiertageTimeData = {
  ...INITIAL_INDEPENDENT_DATA,
  land: ''
};

export const INITIAL_COMPONENT_STATE: ComponentState = {
  jahr: { checked: false, data: { ...INITIAL_INDEPENDENT_DATA } },
  monat: { checked: false, data: { ...INITIAL_INDEPENDENT_DATA } },
  woche: { checked: false, data: { ...INITIAL_INDEPENDENT_DATA } },
  tag: { checked: false, data: { ...INITIAL_INDEPENDENT_DATA } },
  feiertag: { checked: false, data: { ...INITIAL_FEIERTAGE_DATA } },
  zeitzone: 'UTC'
};
